/**
 * This is the starting point of your application.
 * oneAudi OS and Feature Hub Apps will use this file to bootstrap the app.
 */
import React, { useContext, useEffect } from 'react';
import { getReadyAdditionalObjects } from '../tracking/getReadyAdditionalObjects';
import { readyEvent } from '../tracking/readyEvent';

import { ContentTiles } from './components/ContentTiles';
import { ContentContext } from './context/ContentContext';
import { useTrackingService } from './hooks/useTrackingService';

// 🔥 [E] 👇
import { readyEvent as pctReadyEvent } from './__ember__personalization/analytics/readyEvent';
import { Demo } from './__ember__personalization/Demo';
import { ModelBand } from './__ember__personalization/ModelBand';
import { ErrorBoundary } from './__ember__personalization/ErrorBoundary';
// 🔥 [E] ☝️

const FeatureApp: React.FC = () => {
  const context = useContext(ContentContext);
  const { trackingService } = useTrackingService();

  useEffect(() => {
    if (trackingService) {
      trackingService.track({
        event: context.isInContentTileMode ? readyEvent : pctReadyEvent, // 🔥 [E]
        componentUpdate: getReadyAdditionalObjects(),
      });
    }
  }, [trackingService]);

  return (
    <>
      <Demo data-testid="🔥 [E]" />
      <ErrorBoundary
        data-testid="🔥 [E]"
        updateContext={() => {
          if (context.setPersonalizedResults) {
            context.setPersonalizedResults(null);
          }
        }}
        fallback={<ContentTiles {...context.content} />}
      >
        <ContentTiles {...context.content} />
      </ErrorBoundary>
      <ModelBand data-testid="🔥 [E]" />
    </>
  );
};

export default FeatureApp;
